import { useState, useEffect } from 'react';

const useRestaurantInfo = (restaurantUserId) => {
  const [restaurantInfo, setRestaurantInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    
    if (!restaurantUserId) {
      return;
    }

    const fetchRestaurantInfo = async () => {
      setLoading(true);
      try {
        const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/restaurant/${restaurantUserId}`;
        
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        });

        if (response.ok) {
          const data = await response.json();
          setRestaurantInfo(data.data);
          setError(null);
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch restaurant info');
      } finally {
        setLoading(false);
      }
    };

    fetchRestaurantInfo();
  }, [restaurantUserId]);

  return { restaurantInfo, loading, error };
};

export default useRestaurantInfo; 